<template>
  <div class="dropdown-container category">
    <div class="heading" @click="handleDropDownClick">
      <h4 class="title">{{ filtername }}</h4>
      <span
        :class="configuration[filtername].expanded ? 'up-arrow' : 'down-arrow'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="inherit"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.585 8.58496L12 13.17L7.415 8.58496L6 9.99996L12 16L18 9.99996L16.585 8.58496Z"
            fill="inherit" />
        </svg>
      </span>
    </div>
    <div v-if="configuration[filtername].expanded" class="content">
      <v-select
        multiple
        :options="userlist"
        :filterable="false"
        :value="isEmpty(value) ? '' : value"
        label="displayName"
        placeholder="Enter name or APM ID"
        class="filter-container-contents-dropdown"
        :close-on-select="false"
        @search="onSearch"
        @input="setSelected">
        <template #search="{ attributes, events }">
          <input
            class="dropdown-select vs__search"
            v-bind="attributes"
            v-on="events" />
        </template>
        <template #selected-option-container="{ option, deselect }">
          <div
            v-tooltip="tooltipText(option)"
            class="vs__selected dropdown-selected-values">
            <span class="dropdown-selected-values-content">{{
              option.displayName
            }}</span>
            <button
              type="button"
              title="deselect"
              aria-label="deselect"
              class="dropdown-selected-values-button"
              @click="deselect(option)">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="var(--primary-text)"
                stroke="var(--primary-text)"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 9L1 1M1 9L9 1L1 9Z"
                  stroke="inherit"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </template>
        <template #no-options="{ searching }">
          <template v-if="searching">
            <em class="dropdown-no-options">No results found</em>
          </template>
          <em v-else class="dropdown-no-options">No Options</em>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
// Importing Vue and Vue Select
import Vue from "vue";
import vSelect from "vue-select";

// Importing the Vue Select Styles
import "vue-select/dist/vue-select.css";

// Utilities
import AxiosFetch from "@/utils/axios";
import {
  debounce,
  isEmpty,
  getMsalAccessToken,
  getMsalIdToken,
} from "@/utils/helpers";

// Registering the Vue Select Component
Vue.component("VSelect", vSelect);

// Importing the User Actions
import { userActions } from "@/actions";

export default {
  name: "DropdownFilter",
  props: {
    filtername: {
      type: String,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, Object],
      default: () => {},
    },
  },
  data() {
    return {
      userlist: [],
    };
  },
  methods: {
    handleDropDownClick() {
      this.$emit("handleFilterToggle", `${this.filtername}`);
    },
    onSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: debounce(async (loading, search, vm) => {
      //const msalToken = await getMsalToken(vm);
      const opts = userActions.getUserLists(
        search,
        `Bearer ${await getMsalIdToken(this)}`,
        `Bearer ${await getMsalAccessToken(this)}`
      );
      const {
        data: { value },
      } = await AxiosFetch(opts);
      vm.userlist = value;
      loading(false);
    }, 350),
    setSelected(value) {
      this.$emit("handleFilterChange", {
        type: "dropdown",
        filterName: this.filtername,
        value: value,
      });
    },
    tooltipText(item) {
      return item?.displayName || "";
    },
    isEmpty,
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-direction: column;
  width: 12.25rem;
  border-radius: 0.25rem;
  background: white;
  cursor: pointer;
  padding: 0.75rem;

  &-display {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &-title {
      margin: 0;
      font-size: 0.875rem;
      font-family: "MaerskText Regular";
      color: #000000;
    }

    &-up-arrow {
      transform: rotate(180deg);
    }
  }

  &-contents {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 0.5rem;

    &-dropdown {
      width: 100%;
      font-size: 0.875rem;
      background: var(--search-bar-bg);

      & .dropdown-select {
        color: var(--filter-background-color);
        font-size: 14px;
      }

      & .dropdown-no-options {
        opacity: 0.5;
      }

      & .dropdown-selected-values {
        background: transparent;
        color: var(--primary-text);
        font-family: "MaerskText Regular";

        &-content {
          padding: 4px 8px;
          border-right: 1px solid var(--tab-border);
        }

        &-button {
          padding: 0px 8px;
          background: transparent;
          border: none;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dropdown-container {
  & .vs__dropdown-toggle {
    height: auto;
  }

  & .vs__actions {
    display: static;
    padding-bottom: 4px;
    padding-right: 20px;
  }

  & .vs__dropdown-toggle {
    max-height: 200px;
    overflow: visible !important;
  }
  & .vs__selected-options {
    max-height: 200px;
    overflow: auto !important;
    width: 90% !important;
  }

  & .vs__open-indicator {
    position: absolute;
    bottom: 12px;
    right: 4px;
  }
}
</style>
